import { useMemo } from 'react';

import { Brand, Enterprise } from 'apis/enterprise/types';
import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

import { useEnterpriseBrandSearch } from './useEnterpriseBrandSearch';
import { useMerchantSearch } from './useMerchantSearch';

export type UseSearchState = {
  brands: Brand[];
  enterprises: Enterprise[];
  isLoading: boolean;
  merchants: Merchant[];
  venues: Venue[];
};

// Searches across all entities: enterprises, brands, merchants, venue groups, venues.
export const useSearch = (searchQuery: string, isEnabled: boolean): UseSearchState => {
  const { data: searchResults, isLoading: isSearchFetching } = useMerchantSearch(searchQuery, isEnabled);
  const { merchants, venues } = searchResults;

  const { data: searchEnterpriseAndBrandResults, isSearching: isSearchingEnterprisesAndBrands } =
    useEnterpriseBrandSearch(searchQuery, isEnabled);

  const { enterprises: enterpriseSearchResults, brands: brandSearchResults } = searchEnterpriseAndBrandResults;

  const enterprises = useMemo(() => enterpriseSearchResults, [enterpriseSearchResults]);
  const brands = useMemo(() => brandSearchResults, [brandSearchResults]);

  const isLoading = isSearchFetching || isSearchingEnterprisesAndBrands;

  return {
    brands,
    enterprises,
    isLoading,
    merchants,
    venues,
  };
};
